import { WIDGET_TYPES } from '../core/widgetTypes';
import { registerWidget } from './index';
import TitleWidget from './TitleWidget';
import SingleWidget from './SingleWidget';
import TableWidget from './TableWidget';
import PatientFormsWidget from './PatientFormsWidget';
import DateFilterWidget from './DateFilterWidget';
import DropdownFilterWidget from './DropdownFilterWidget';
import PharmLocationFilterWidget from '../PharmLocationFilterWidget';
import LineChartWidget from './LineChartWidget';
import BarChartWidget from './BarChartWidget';
import PieChartWidget from './PieChartWidget';

var isRegistered = false;

export function registerDefaultWidgets() {
  if (isRegistered) {
    return;
  }

  registerWidget(WIDGET_TYPES.TITLE, TitleWidget);
  registerWidget(WIDGET_TYPES.SINGLE, SingleWidget);
  registerWidget(WIDGET_TYPES.TABLE, TableWidget);
  registerWidget(WIDGET_TYPES.PATIENT_FORMS, PatientFormsWidget);
  registerWidget(WIDGET_TYPES.FILTER_DATE, DateFilterWidget);
  registerWidget(WIDGET_TYPES.FILTER_DROPDOWN, DropdownFilterWidget);
  registerWidget(WIDGET_TYPES.FILTER_DROPDOWN_PHARMLOCATION, PharmLocationFilterWidget);
  registerWidget(WIDGET_TYPES.LINE, LineChartWidget);
  registerWidget(WIDGET_TYPES.BAR, BarChartWidget);
  registerWidget(WIDGET_TYPES.PIE, PieChartWidget);

  isRegistered = true;
}
